import React, {useState} from "react";
import database from '../firebase';
import "./LoginPhone.css";
import { useHistory } from "react-router-dom";

export default function LoginPhone() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [English, setEnglish] = useState(true);
    const history = useHistory();
    

    const handleLogin =() =>{
        database.auth().signInWithEmailAndPassword(email,password)
            .then(()=>{
                var user = database.auth().currentUser;
                setEmail("");
                setPassword("");
                const path = `/${user.uid}`;
                history.push(path);
            }).catch((err)=>{
                setEmail("");
                setPassword("");
                alert(err);
        });
    }

    const ChangeToChinese =()=>{
        setEnglish(false);
    }

    const ChangeToEnglish =()=>{
        setEnglish(true);
    }

    return (
        <div> 
            {English?(
                <>
                <div className="LoginPhone">
                <h1> Login Page</h1>
                <div className="LoginPhone-Language" onClick={ChangeToChinese}> <h3>中文</h3></div>
                
                <div className="LoginPhone-box">
                <label style={{marginTop:'40px'}}>Email：</label>
                <input type="text" required value={email}
                    placeholder = "   Email" style={{marginTop:'-23px'}}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <label style={{marginTop:'25px'}}>Password：</label>
                <input type="password" required value={password}
                    placeholder = "   Password" style={{marginTop:'-23px'}}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button style={{marginTop:'20px'}} onClick={handleLogin}><h6>Login</h6> </button>
                </div>
                </div>
                </>
            ):(
                <div className="LoginPhone">
                <h1> 登入页面</h1>
                <div className="LoginPhone-Language" onClick={ChangeToEnglish}> <h3>English</h3></div>
                
                <div className="LoginPhone-box">
                <label style={{marginTop:'40px'}}>邮箱：</label>
                <input type="text" required value={email}
                    placeholder = "   邮箱" style={{marginTop:'-23px'}}
                    onChange={(e) => setEmail(e.target.value)}
                /><br/>

                <label style={{marginTop:'25px'}}>密码：</label>
                <input type="password" required value={password}
                    placeholder = "   密码" style={{marginTop:'-23px'}}
                    onChange={(e) => setPassword(e.target.value)}
                /><br/>

                <button style={{marginTop:'20px'}} onClick={handleLogin}><h6>登入</h6> </button><br/>
                </div>
                </div>
            )}
        </div>  
        
    );
     
}